import state from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

/**
 * Determine if the Vuex module should be namespaced.
 *
 * @type {Boolean}
 */
const namespaced = true

/**
 * Export the immutable Vuex store module.
 *
 * @type {Object}
 */
export default {
	state,
	actions,
	getters,
	mutations,
	namespaced,
}
